export default __webpack_public_path__ + "static/media/live_help_24px.c9957f47.svg";